module.exports = __webpack_public_path__ + "static/project1-432fcd6cc09263b2a195584d4d971775.svg";